import { render, staticRenderFns } from "./AbkSurveyStep3Form.vue?vue&type=template&id=35f70579&scoped=true&"
import script from "./AbkSurveyStep3Form.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyStep3Form.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyStep3Form.vue?vue&type=style&index=0&id=35f70579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f70579",
  null
  
)

export default component.exports